<app-navbar-licencas (confirmarAlteracao)="confirmarAlteracao()"></app-navbar-licencas>
<div class="overflow-auto w-100 h-88 padding-1  scroll-personalizado"
    [class.blur]="modalAberto || confirmarAlteracaoModal || autenticarModal || configValidarModal">
    <span titulo>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.TITLE" | transloco }}</span>
    <div class="d-flex flex-column gp-2 margin-top-1">
        <div header>
            <span sub-titulo>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.CONTROLS_TYPES" | transloco }}</span>
            <div container-infos header>
                @for (tipoControle of tiposControle; track $index) {
                <button (click)="this.mudarConfiguracoesAtivas(tipoControle.nome)"
                    [class.active]="opcaoEstaAtiva(tipoControle.nome)">{{tipoControle.nomeFormatado}}</button>
                }
            </div>
        </div>

        @for (controle of configuracoesControles; track $index; let indiceControle = $index) {
        <div *ngIf="opcaoEstaAtiva(controle.tipoControle) && !['mpa', 'alimentadora'].includes(controle.tipoControle)">
            <span sub-titulo>{{controle.nomeControle}}</span>
            <div container-infos class="justify-content-around flex-column">
                <div margin-bottom class="d-flex align-items-center"
                    *ngIf="['solido', 'liquido'].includes(controle.tipoControle)">
                    <span class="font-15 fw-bold">
                        {{ (controle.tipoControle == 'solido' ? 
                            'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.ACTIVATION_CAIXAS' : 
                            'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.ACTIVATION_TANQUES') | transloco }}
                    </span>

                    @for (configuracao of controle.configuracoes; track $index; let indiceCaixaTanque = $index) {
                    <div container-btn-solido>
                        <button
                            (click)="controle.configuracoes[indiceCaixaTanque] = esvaziarControladorasSensoresSelecionadosConfiguracao(configuracao)"
                            [class.active]="configuracao.selecionado">{{indiceCaixaTanque + 1}}</button>
                    </div>
                    }
                </div>

                @for (configuracao of controle.configuracoes; track $index; let indiceCaixaTanque = $index) {
                <div class="d-flex flex-row justify-content-center align-items-center w-100"
                    *ngIf="configuracao.selecionado"
                    [class.mt-0]="!['solido', 'liquido'].includes(controle.tipoControle)">
                    <ul class="d-flex justify-content-between align-items-center w-100 m-0"
                        [class.lista-com-divisorias]="['solido', 'liquido'].includes(controle.tipoControle)">
                        <li insumo-config class="d-flex justify-content-around align-items-center w-100 mt-0">
                            <span *ngIf="['solido', 'liquido'].includes(controle.tipoControle)" class="font-15 fw-bold">
                                {{ (controle.tipoControle == 'solido' ? 
                                    'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.CAIXA' : 
                                    'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.TANQUE') | transloco }}
                                {{ (indiceCaixaTanque + 1) }}
                            </span>
                            <button class="btn-muda"
                                (click)="abrirModal(configuracao, controle.tipoControle, controle.nomeControle, 'controladoras')">
                                <div class="d-flex align-items-center w-100 h-100"
                                    [class.justify-content-center]="!configuracaoTem(configuracao, 'controladoras')">
                                    <span class="font-08">
                                        {{ (!configuracaoTem(configuracao, 'controladoras') ? 
                                            'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.NONE_CONTROL' : 
                                            'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.CONTROLADOR') | transloco }}
                                    </span>

                                    @if (configuracaoTem(configuracao, 'controladoras')) {
                                    <ul class="d-flex align-items-center justify-content-end w-100 h-100 m-0 gap-02">
                                        @for (controladora of configuracao.controladoras.selecionados; track $index) {
                                        <li class="card-ativo">
                                            {{controladora}}
                                        </li>
                                        }
                                    </ul>
                                    }
                                </div>
                            </button>
                            <button class="btn-muda"
                                (click)="abrirModal(configuracao, controle.tipoControle, controle.nomeControle, 'sensores')">
                                <div class="d-flex align-items-center w-100 h-100"
                                    [class.justify-content-center]="!configuracaoTem(configuracao, 'sensores')">
                                    <span class="font-08">
                                        {{ (!configuracaoTem(configuracao, 'sensores') ? 
                                            'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.NONE_SENSOR' : 
                                            'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.SENSORES') | transloco }}
                                    </span>

                                    @if (configuracaoTem(configuracao, 'sensores')) {
                                    <ul class="d-flex align-items-center justify-content-end w-100 h-100 m-0 gap-02">
                                        @for (sensor of configuracao.sensores.selecionados; track $index) {
                                        <li class="card-ativo">
                                            {{sensor}}
                                        </li>
                                        }
                                    </ul>
                                    }
                                </div>
                            </button>
                        </li>
                    </ul>
                </div>
                }
            </div>
        </div>
        }
    </div>
</div>
<app-configs-modal *ngIf="modalAberto" [controladoresSensoresEmUso]="indisponiveisParaControladorSensorSelecionado"
    [configs]="dadosConfiguracaoSelecionada" [valoresSelecionados]="valoresSelecionados"
    (eventoModal)="receberDados($event)"></app-configs-modal>
<app-confirmar-alteracoes-modal [erros]="erros" (eventoModal)="receberConfirmarModal($event)"
    [hidden]="!confirmarAlteracaoModal"></app-confirmar-alteracoes-modal>
<app-autenticacao-modal (enviarDados)="receberDadosAutorizacaoModal($event)"
    [hidden]="!autenticarModal"></app-autenticacao-modal>
<app-configuracao-validada-modal [hidden]="!configValidarModal"
    (enviarDados)="receberDadosAtualizacaoFeitaModal()"></app-configuracao-validada-modal>